import classnames from "classnames";

import Button from "@/components/botanic/Button";

import styles from "./SwitchToMapButton.module.css";

type Props = {
  showMapButton: boolean;
  onClick: () => void;
};

export default function SwitchToMapButton({ showMapButton, onClick }: Props) {
  return (
    <div
      className={classnames(
        styles.hideButton,
        styles.mobileListingTransition,
        "md:hidden text-xs bg-white px-md py-sm fixed bottom-0 left-0 right-0 shadow-low z-10 ",
        showMapButton && styles.showButton,
      )}
    >
      <Button variant="secondary" iconFilePath="map.svg" onClick={onClick}>
        switch to map view
      </Button>
    </div>
  );
}
